import { getLastUpdated } from 'common/services/pdt.service';
import { useEffect, useState } from 'react';

const useLastUpdatedValue = ({ projectId = null } = {}) => {
  const [lastUpdated, setLastUpdated] = useState('');
  const fetchLastUpdatedValue = async () => {
    try {
      const lastUpdated = await getLastUpdated({ projectId });
      setLastUpdated(lastUpdated);
    } catch (error) {
      setLastUpdated('');
    }
  };

  useEffect(() => {
    fetchLastUpdatedValue();
  }, [projectId]);

  return lastUpdated;
};

export default useLastUpdatedValue;
